import React from 'react'
import classes from './Loading.css'
import LoadingIcon from 'static/images/loading.svg'

export const Loading = props => {
  const {
    size = 'small',
  } = props

  return (
    <div className={classes.loaderWrapper}>
      <div className={classes[size]}>
        <LoadingIcon />
      </div>
    </div>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/legacy/components/Loading/Loading.jsx